import React from "react";
import { PureModal } from "components/ui";
import CancelAppointmentConfirmation from "./index.jsx"
import PropTypes from "prop-types";

export default function CardCancelAppointmentButton({ setIsSubmitting, onSuccess, appointmentId, patientsToBeNotified }) {

    return (
        <PureModal
            maxWidth="sm"
            fullWidth
            renderTrigger={({ openModal }) => (
                <button
                    className="appointment-action-button cancel-appointment-button"
                    style={{ marginLeft: 10 }}
                    onClick={() => { openModal() }}
                >
                    Cancel Appointment
                </button>
            )}
            renderContent={({ closeModal }) => (
                <CancelAppointmentConfirmation
                    setIsSubmitting={setIsSubmitting}
                    onSuccess={onSuccess}
                    closeModal={closeModal}
                    appointmentId={appointmentId}
                    patientsToBeNotified={patientsToBeNotified}
                />
            )}

        />
    )
}

CardCancelAppointmentButton.propTypes = {
    setIsSubmitting: PropTypes.func, 
    onSuccess: PropTypes.func, 
    appointmentId: PropTypes.number, 
    patientsToBeNotified: PropTypes.number
}